



































































import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';
import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SettingConfirm as confirmTerms} from '@/const/terms/feedback/confirm';
import { SetAudience as feedbackTerms } from '@/const/terms/feedback/audience';

import { AUDIENCE_STATUS } from '@/const/status';
import { PLATFORM_MAP } from '@/const/options';
import { DefaultOption, TableOptionType } from '@/const/options/DefaultTableOption';
import {
    SearchFormType,
    AudienceDataType,
    IAudienceData,
} from './types';

import { Table as ElTable } from 'element-ui';
import { AxiosError, AxiosResponse } from 'axios';

import Select from '@/components/ElementComponent/Select/index.vue';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import AudienceStatusColumn from '@/components/ElementComponent/Column/AudienceStatusColumn.vue';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';

@Component<Audience>({
    name: 'Audience',
    components: {
        Select,
        NumberColumn,
        DateColumn,
        AudienceStatusColumn,
        SelectAllColumn,
    },
})
export default class Audience extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;
    private confirmTerms = confirmTerms;

    private PLATFORM_MAP = PLATFORM_MAP;
    private AUDIENCE_STATUS = AUDIENCE_STATUS;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private deleteConfirmVisible: boolean = false;

    private filterForm: SearchFormType = { status: AUDIENCE_STATUS.ALL, query: '', page: 1, totalPages: 0, sort: null};
    private statusOptions: { value: AUDIENCE_STATUS; label: string; }[] = [
        { value: AUDIENCE_STATUS.SETUP, label: '준비 중' },
        { value: AUDIENCE_STATUS.PROGRESS, label: '적재 진행 중' },
        { value: AUDIENCE_STATUS.READY, label: '준비됨' },
        { value: AUDIENCE_STATUS.ABORT, label: '적재 실패' },
        { value: AUDIENCE_STATUS.DONE, label: '완료됨' },
        { value: AUDIENCE_STATUS.DORMANCY, label: '휴면 중' },
        { value: AUDIENCE_STATUS.ALL, label: '모든 상태'},
    ];
    private tableData: IAudienceData[] = [];
    private selectedAudience: IAudienceData[] = [];

    private handleSelectionChange(val: IAudienceData[]): void {
        this.selectedAudience = val;
    }
    private sortChangeHandler({ column, prop, order }: {column: any, prop: string, order: string}) {
        this.filterForm.sort = prop ? {prop: prop, order: order} : null;
        this.getAudienceResponseHandler();
    }
    private retryAudienceUpload(id: string) {
        if(id && id.length > 0) {
            this.loading = true;
            this.$http.audience.get('retryaudienceupload', {
                params: {
                    audienceId: id,
                },
            }).then((res: any) => res.data)
                .then((data: any) => {
                    this.$notify.success(feedbackTerms.retryAudienceUpload.success);
                    this.loading = false;
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.retryAudienceUpload.error.fail);
                    } else {
                        this.$notify.error(err.message);
                    }
                    this.loading = false;
                    throw err;
                })
        }
    }
    private deleteAudiences() {
        this.deleteConfirmVisible = false;
        
        const targetIDs = this.selectedAudience.map((item: IAudienceData) => {
            return item.id;
        })
        if (targetIDs.length === 0) return true;
        this.loading = true;
        this.$http.adserverAPI.post('DeleteAudience', {
            audience_ids: targetIDs,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.deleteAudience.success);
                    this.getAudienceResponseHandler();
                    return true;
                }
                throw new Error(feedbackTerms.deleteAudience.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.deleteAudience.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                this.loading = false;
                throw err;
            })
    }
    
    private getAudienceResponseHandler() {
        this.loading = true;
        this.selectedAudience = [];
        this.getAudienceResponse().then((res: any) => res.data)
            .then((data: AudienceDataType) => {
                this.tableData = data.audiences;
                this.filterForm.totalPages = data.pages;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200){
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=> {this.loading = false})
    }
    
    private getAudienceResponse() {
        this.setRouteQueryFromFilter();
        const sort = this.filterForm.sort && this.filterForm.sort.prop ? `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}` : '';
        return this.$http.adserverAPI.post('GetAudienceSummary', {
            status: this.filterForm.status,
            query: this.filterForm.query,
            page_no: this.filterForm.page,
            sort: sort,
        });
    }

    private setRouteQueryFromFilter(){
        const query: {[name: string]: any} = {}
        this.filterForm.query && (query.query = this.filterForm.query);
        // this.filterForm.status && (query.status = this.filterForm.status);
        this.filterForm.page && (query.page = this.filterForm.page);
        this.filterForm.sort && this.filterForm.sort.prop && this.filterForm.sort.order && (query.sort = `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}`);

        const newQuery = Object.entries(query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: encodeURIComponent(value)};
        }, {});
        
        if (!(_.isEqual(newQuery, this.$route.query))) {
            this.$router.replace({
                ...this.$route,
                query: newQuery,
            })
        }
    }
    private setRouteQueryToFilter() {
        const query = Object.entries(this.$route.query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: decodeURIComponent(value)};
        }, {}) as any;
        
        query.query !== undefined && (this.filterForm.query = query.query as string);
        // query.status !== undefined && (this.filterForm.status = Number.parseInt(query.status as string) as STATUS);
        query.page !== undefined && (this.filterForm.page = Number.parseInt((query.page as string)));
        query.sort !== undefined && (this.filterForm.sort = (query.sort as string)[0] === '-' ? { 
            order: 'descending', prop: (query.sort as string).slice(1)
        } : {
            order: 'ascending', prop: (query.sort as string)
        });
    }
    private created() {
        this.setRouteQueryToFilter()
    }
    private mounted() {
        this.$nextTick( () => {
            this.getAudienceResponseHandler();
        });
    }
}
